export const BADGES_PATH = '/badges';

export const badgeDetailPath = (badgeId: string): string => `${BADGES_PATH}/${badgeId}`;

export interface BadgeDetailState {
    fromWallet?: boolean;
}
